import { createContext } from 'react';
import { AccountType } from '@make-software/csprclick-core-types';

export const ConnectedAccountContext =
  createContext<AccountType | null>(null);
